import request from '@/utils/request'

export function weChatPay(data){
    return request({
        url: '/api/weChatPay/weChatPay',
        method: 'post',
        data: data
    })
}
export function isWeChatPaySuccess(data){
    return request({
        url: '/api/weChatPay/isWeChatPaySuccess',
        method: 'post',
        data: data
    })
}



//alipay 支付宝支付
export function alipay(data){
    return request({
        url: '/api/aliPay/alipay',
        method: 'post',
        data: data
    })
}
//alipay 支付宝支付查询
export function alipaySelect(data){
    return request({
        url: '/api/aliPay/alipay/select',
        method: 'post',
        data: data
    })
}



// WEBPACK FOOTER //
// ./src/api/pay.js